export const mainNav = {
	init: function () {
		const header = document.querySelector(".header");
		if (!header) return;

		if (!window.bindedMenuEvents) {
			this.toggleNavigation();
			this.assigneEventListeners(header);
		}
		window.addEventListener("resize", this.handleResize);
	},

	// change the mode from slider to accordion when resizing
	handleResize: function () {
		const menuLevel2 = document.querySelectorAll(".menu__level2");
		const menuLevel3 = document.querySelectorAll(".menu__level3");
		if (window.innerWidth < 766 && window.innerWidth < 1200) {
			document.querySelector("nav.menu").style.removeProperty("height");
		} else if (window.innerWidth > 1200) {
			const menuLevel2 = document.querySelectorAll(".menu__level2");
			const menuLevel3 = document.querySelectorAll(".menu__level3");
			menuLevel2.forEach((item) => {
				item.classList.remove("is--hidden");
			});
			menuLevel3.forEach((item) => {
				item.classList.remove("is--hidden");
			});
		} else if (window.innerWidth < 1200) {
			// set hidden footer menu links on mobile
			document.querySelectorAll(".footer__menu .menu__level2").forEach((item) => {
				item.classList.add("is--hidden");
			});
			document.querySelectorAll(".footer__menu .menu__level3").forEach((item) => {
				item.classList.add("is--hidden");
			});
			// set visible footerTopProducts on mobile
			const footerTopProducts = document.querySelector(
				".footer__menu .menu__products--top .menu__level3"
			);
			if (footerTopProducts) {
				footerTopProducts.classList.remove("is--hidden");
			}
		}
	},

	toggleNavigation: function () {
		const header = document.querySelector("header");
		const hamburger = document.querySelector(".main-navigation__hamburger");
		const logo = document.querySelector(".main-navigation__logo");
		if (!hamburger) {
			return false;
		}
		hamburger.addEventListener("click", () => {
			if (hamburger.classList.contains("active")) {
				logo.removeAttribute("tabindex");
				this.hideMobMenu();
				hamburger.ariaExpanded = "false";
			} else {
				logo.setAttribute("tabindex", "-1");
				hamburger.classList.add("active");
				hamburger.ariaExpanded = "true";
				document.body.classList.add("menuActive");
				const menuLevel2 = header.querySelectorAll(".menu__level2");
				const menuButtons = header.querySelectorAll("button.more");
				this.setMobileMenu(menuLevel2, menuButtons);

				$(".menu").animate(
					{
						left: "0px",
					},
					400,
					function (e) {}
				);
				// setting the height of the menu container adjusting to the height of the floatingbutton2
				if (window.innerWidth < 766) {
					const floatingbutton2 = document.querySelector(
						".floatingbutton2 .placeholder.placeholder--b2c-dgray"
					);

					if (floatingbutton2) {
						const floatingbutton2Height = Math.floor(
							floatingbutton2.getBoundingClientRect().height
						);
						document.querySelector(
							"nav.menu"
						).style.bottom = `${floatingbutton2Height}px`;
						document.querySelector("nav.menu").style.height = "auto";
					}
				}
			}
		});
		document.addEventListener('keydown', (e) => {
			if (e.key === "Escape" && hamburger.classList.contains('active')) {
				this.hideMobMenu();
				// console.log("ukryjmy menu");
				hamburger.ariaExpanded = "false";
				hamburger.classList.remove('active');
			}
		})
	},

	hideMobMenu: function () {
		const level = document.querySelector(".client-type-navigation__active-site");
		const menuList3 = document.querySelectorAll(".menu__list3");
		const menuLevel2 = document.querySelectorAll(".menu__level2");
		if (menuLevel2) {
			[].forEach.call(menuLevel2, (el) => {
				el.style.left = "";
			});
		}
		// document.querySelector('.menu__list3').removeAttribute('style'); <--- That was in b2b
		if (menuList3) {
			[].forEach.call(menuList3, (el) => {
				el.style.left = "";
			});
		}
		if (document.querySelector(".menu__list.menu__list--mobile")) {
			document
				.querySelector(".menu__list.menu__list--mobile")
				.removeAttribute("style");
		}
		level.textContent = level.dataset.site;
		document
			.querySelector(".main-navigation__hamburger")
			.classList.remove("active");
		$(".menu").animate(
			{
				left: "-320px",
			},
			400,
			function (e) {
				document.body.classList.remove("menuActive");
			}
		);
	},

	assigneEventListeners: function (header) {
		window.bindedMenuEvents = true;
		const wrapper = document.querySelector(".wrapper");
		const allLinks = header.querySelectorAll(
			".menu__list-b2c button.more, .menu__list button.more"
		);

		const allSpanMore = header.querySelectorAll(
			".menu__list-b2c span.more, .menu__list span.more"
		);
		const clientNav = header.querySelector(".client-type-navigation");
		const topActiveNav = clientNav.querySelector(
			".client-type-navigation__active-site"
		);

		// old menu
		const firstLevelMenuClasses = {
			backBtn: "backToSite",
			menuLv: "data-level1",
		};
		const secondLevelMenuClasses = {
			backBtn: "backToLevel",
			menuLv: "data-level2",
		};

		const subcategoryProducts = header.querySelectorAll(
			".menu-products-list--subcategory"
		);

		[].forEach.call(allLinks, (el) => {
			el.setAttribute("aria-expanded", "false");
			el.addEventListener("click", (e) => {
				if (window.innerWidth < 1200) {
					this.toggleActiveItems(el, allLinks, e);
					if (subcategoryProducts) {
						this.handleSubcategoryHeading(subcategoryProducts);
					}
				} else {
					this.openMenuDesktop(e);
				}
			});
		});

		if (subcategoryProducts) {
			this.handleSubcategoryHeading(subcategoryProducts);
		}
		// old menu
		[].forEach.call(allSpanMore, (el) => {
			el.addEventListener("click", (e) => {
				this.openMenu(e, topActiveNav, secondLevelMenuClasses, clientNav);
			});
			el.addEventListener("keydown", (e) => {
				if (e.keyCode === 13 || e.keyCode === 32) {
					this.openMenu(e, topActiveNav, secondLevelMenuClasses, clientNav);
				}
			});
		});

		wrapper.addEventListener("click", (e) => {
			if (window.innerWidth < 1200) {
				this.hideMobMenu();
			} else {
				const opened = document.querySelector(
					".menu__list-b2c .openned, .menu__list .openned"
				);
				// const button = opened.querySelector('button.more')
				if (opened) {
					opened.classList.remove("openned");
				// 	button.setAttribute("aria-expanded", "false");
				// } else {
				// 	button.setAttribute("aria-expanded", "true");
				}
			}
		});
		document.addEventListener('keydown', (e) => {
			const opened = document.querySelector(
					".menu__list-b2c .openned, .menu__list .openned"
				);
			if (e.key === "Escape" && opened) {
				// console.log("ukryjmy menu");
				let button = opened.querySelector('.more');
				button.ariaExpanded = "false";
				opened.classList.remove('openned');
			}
		})
		window.addEventListener('search-toggled', (e) => {
				const searchBtn = document.querySelector('[data-btn="searchInput"]');
				if (searchBtn) {
					searchBtn.ariaExpanded =  String(e.detail.isOpen);
				}
		});

	},

	openMenuDesktop: function (e) {
		e.preventDefault();
		let li_el = e.currentTarget.parentNode;
		while (li_el.tagName !== "LI") {
			li_el = li_el.parentNode;
		}
		let open_el = document.querySelector(
			".menu__list-b2c .openned, .menu__list .openned"
		);
		// console.log('open me:', open_el)
		const buttons = document.querySelectorAll(".menu__list-b2c .more");
		let button = li_el.querySelector(".more");
		// console.log('open me:', button)
		if (open_el != li_el && open_el) {
			open_el.classList.remove("openned");
			button.ariaExpanded = 'false';
			// if (button) button.setAttribute("aria-expanded", "true");
		}
		li_el.classList.toggle("openned");
		if (li_el.classList.contains("openned")) {
			buttons.forEach((buttonEl) => {
			buttonEl.ariaExpanded = 'false';
		});
			button.ariaExpanded = 'true';
		} else {
			button.ariaExpanded = 'false';
		}
		// console.log('open me:', li_el, open_el)
	},

	openMenu: function (e, topActiveNav, menuClasses, clientNav) {
		e.preventDefault();
		if (window.innerWidth < 1200) {
			let target = e.target;
			while (target.tagName !== "BUTTON" && !target.classList.contains("more")) {
				target = target.parentNode;
			}
			const nextLevel = target.nextElementSibling;
			const back = target.closest(".menu").dataset.back;
			const currentName = target.textContent; // nextLevel.style.left = '0px';
			$(nextLevel).addClass("mob_openned");
			$(nextLevel).animate(
				{
					left: "0px",
				},
				200,
				function (e) {}
			);
			const backToSite = nextLevel.querySelector(`.${menuClasses.backBtn}`);
			if (backToSite === null) {
				nextLevel.insertBefore(
					this.createBackEl(back, menuClasses.backBtn),
					nextLevel.childNodes[0]
				);
				this.backButtonClick(`.${menuClasses.backBtn}`, topActiveNav, clientNav);
			}
			topActiveNav.setAttribute(menuClasses.menuLv, currentName);
			if (!clientNav.classList.contains("top-menu-b2b")) {
				topActiveNav.textContent = currentName;
			}
		} else {
			let li_el = e.currentTarget.parentNode;
			while (li_el.tagName !== "LI") {
				li_el = li_el.parentNode;
			}
			let open_el = document.querySelector(
				".menu__list-b2c .openned, .menu__list .openned"
			);
			if (open_el != li_el && open_el) {
				open_el.classList.remove("openned");
			}
			li_el.classList.toggle("openned");
		}
	},

	// old menu
	createBackEl: function (back, backBtnClass) {
		const newEl = document.createElement("button");
		newEl.classList.add("back", backBtnClass);
		newEl.innerHTML = back;
		return newEl;
	},

	backButtonClick: function (className, topActiveNav, clientNav) {
		const backBtn = document.querySelectorAll(className);
		[].forEach.call(backBtn, (el) => {
			el.addEventListener("click", (e) => {
				let par_el = e.currentTarget.parentNode;
				par_el.style.left = "-320px";

				$(par_el).animate(
					{
						left: "-320px",
					},
					400,
					function (e) {
						// Animation complete.
						$(par_el).removeClass("mob_openned");
					}
				);
				//ustawic focus na ele ktory klinal
				par_el.removeChild(e.currentTarget);
				if (!clientNav.classList.contains("top-menu-b2b")) {
					if (e.target.classList.contains("backToSite")) {
						topActiveNav.innerText = topActiveNav.dataset.site;
					}
					if (e.target.classList.contains("backToLevel")) {
						topActiveNav.innerText = topActiveNav.dataset.level1;
					}
				}
			});
		});
	},
	// hide items from lower levels, set aria attributes
	setMobileMenu: function (contents, buttons) {
		contents.forEach((content) => {
			this.hideElement(content);
		});
		buttons.forEach((button) => {
			button.setAttribute("aria-expanded", "false");
		});
	},

	hideElement: function (elem) {
		elem.classList.add("is--hidden");
	},

	// click handling higher level items on the mobile menu
	handleSubcategoryHeading: function (subcategoryMenu) {
		if (window.innerWidth < 1200) {
			const buttons = [];
			subcategoryMenu.forEach((subcategoryItem) => {
				subcategoryItem
					.querySelector(".menu-products-list__wrapper")
					.classList.add("is--hidden");
				const button = subcategoryItem.querySelector(
					".menu-products-list__heading"
				);
				buttons.push(button);
			});
			buttons.forEach((button) => {
				button.style.cursor = "pointer";
				button.setAttribute("aria-expanded", "false");
				button.addEventListener("click", (e) => {
					const buttonActive = button.getAttribute("aria-expanded");
					// chceck is submenu is active
					if (buttonActive === "false") {
						e.stopImmediatePropagation();
						this.toggleActiveItems(button, buttons, e);
						button.setAttribute("aria-expanded", "true");
					} else {
						const anchor = button.querySelector("a");
						// check if the link has been clicked
						if (e.target == anchor) {
							const link = anchor.href;
							location.href = link;
						} else {
							this.toggleActiveItems(button, buttons, e);
						}
					}
				});
			});
		}
	},

	toggleActiveItems: function (item, items, e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		if (window.innerWidth < 1200) {
			const itemToggle = item.getAttribute("aria-expanded");
			for (let i = 0; i < items.length; i++) {
				items[i].ariaExpanded = 'false';
				// items[i].setAttribute("aria-expanded", "false");
				items[i].nextElementSibling.classList.add("is--hidden");
			}
			if (itemToggle === "false") {
				// item.setAttribute("aria-expanded", "true");
				item.ariaExpanded = 'true';;
				const submenu = item.nextElementSibling;
				submenu.classList.remove("is--hidden");
			}
		}
	},
};
